import { render, staticRenderFns } from "./MarksDeleteConfirm.vue?vue&type=template&id=703f9f59"
import script from "./MarksDeleteConfirm.vue?vue&type=script&lang=js"
export * from "./MarksDeleteConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports